import { useState, useContext } from 'react'
import { Col, Container, Row } from 'react-grid-system'
import { Outlet } from 'react-router-dom'

import Nav from '../../components/nav/Nav'
import { CheckoutCartContext } from '../../contexts/CheckoutCartContext'
import { UserContext } from '../../contexts/UserContext'
import CheckoutCart from './components/CheckoutCart'
import CheckoutSideNav from './components/CheckoutSideNav'
import { RESTAURANT_NAME } from '../../constants'

function Checkout() {
  const [checkoutCartItems, setCheckoutCartItems] = useState([])
  const { user } = useContext(UserContext)

  return (
    <CheckoutCartContext.Provider
      value={{ checkoutCartItems, setCheckoutCartItems }}
    >
      <Container fluid>
        <Nav />
        <Row>
          <Col md={2}>
            {!user && (
              <img
                src="https://api.dineoncampus.com/files/images/0e8a5d9c-8651-48be-8155-dd720533e9dd.png"
                style={{ width: '200px', marginTop: 'var(--md)' }}
                alt={RESTAURANT_NAME}
              />
            )}
            <br />
            <CheckoutSideNav />
          </Col>
          <Col md={6.5}>
            <br />
            <Outlet />
          </Col>
          <Col md={3.5}>
            <CheckoutCart />
          </Col>
        </Row>
      </Container>
    </CheckoutCartContext.Provider>
  )
}

export default Checkout
